/**
 * Usage:
 *
 * data-sw-user-orientation-price-change
 *
 * data-sw-shapejs-viewer-creator-id="{{ getCreatorId }}"
 */

var $ = require('js/sw-jquery/sw-jquery');

module.exports = function($fragment) {
   $fragment.swFindWithSelf('[data-sw-user-orientation-price-change]').each(function() {
     var $el = $(this);
     require([
       'js/lib/views/UserOrientationPriceChange',
       'js/lib/models/ModelManager'
     ], function(UserOrientationPriceChange, ModelManager) {
       var creatorId = $el.data('swShapejsViewerCreatorId');

       var shapeJsModel = ModelManager.getShapeJs(creatorId);

       new UserOrientationPriceChange({
         stateId: creatorId,
         el: $el,
         model: shapeJsModel
      });
    });
  });
};
